export default {"src":"/_next/static/media/delete-account.d022047d.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};